<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Renda Fixa - Título Privado"
    [operationDate]="this.model.operationDate"
    [id]="this.model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="row">
    <div class="col-md-6 col-12">
      <div class="card">
        <div class="card-header text-uppercase">Tipo de Liquidação</div>
        <div class="card-body">
          <div class="col-12">
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaTipoLiquidacao; index as i"
            >
              <input
                class="form-check-input"
                type="radio"
                id="TipoLiquidacao-{{ i }}-id"
                name="settlementTypeId"
                [(ngModel)]="model.settlementTypeId"
                [value]="item.id"
                required
              />
              <label class="form-check-label" for="TipoLiquidacao-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card">
        <div class="card-header text-uppercase">Tipo de Operação</div>
        <div class="card-body">
          <div class="col-12" [class.has-error]="hasError('operationTypeId')">
            <div *ngIf="isTED() || isCETIP()">
              <div
                class="form-check form-check-inline"
                *ngFor="let item of TiposCompra; index as i"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  id="TipoOperacao-{{ i }}-id"
                  name="operationTypeId"
                  [(ngModel)]="model.operationTypeId"
                  [value]="item.id"
                  [required]="isTED() || isCETIP()"
                />

                <label class="form-check-label" for="TipoOperacao-{{ i }}-id">
                  {{ item.name }}
                </label>
              </div>
            </div>

            <div *ngIf="isNoFinancial()">
              <div
                class="form-check form-check-inline"
                *ngFor="let item of ListaNoFinancial; index as i"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  id="TipoOperacaoNoFinancial-{{ i }}-id"
                  name="operationTypeId"
                  [(ngModel)]="model.operationTypeId"
                  [value]="item.id"
                  [required]="isNoFinancial"
                />

                <label
                  class="form-check-label"
                  for="TipoOperacaoNoFinancial-{{ i }}-id"
                >
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.CETIP"
    [settlementType]="model.settlementTypeId"
    [operationType]="model.operationTypeId"
    (emitterStockSelectedItem)="getStockSelectedFixedIncome($event)"
  >
  </app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('amount')">
          <label>Quantidade</label>
          <input
            type="text"
            class="form-control"
            data-cy="amount"
            name="amount"
            [(ngModel)]="model.amount"
            [required]="isAmountRequired()"
            maxlength="17"
            (ngModelChange)="calculateOperationValue()"
          />
        </div>

        <div class="col-4" [class.has-error]="hasError('unitPrice')">
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            class="form-control"
            data-cy="unitPrice"
            name="unitPrice"
            [(ngModel)]="model.unitPrice"
            [required]="isSell() || isPurchase()"
            maxlength="35"
            [textMask]="{ mask: validator.unitPriceMask }"
            (ngModelChange)="calculateOperationValue()"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('isSecondaryMarket')">
          <label for="termo"
            >Mercado Secundário
            <fa-icon
              *ngIf="this.model.isSecondaryMarket"
              [icon]="faInfoCircle"
              title="Se você negociou este ativo no mercado secundário, é necessário anexar, comprovante de compra e venda, nota de recolhimento e qualquer outro documento que comprove idoneidade"
            ></fa-icon>
          </label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                data-cy="isSecondaryMarketTrue"
                id="termo-1"
                name="termo"
                type="radio"
                [value]="true"
                [(ngModel)]="this.model.isSecondaryMarket"
                (change)="setSettlementDateBySecondaryMarket()"
              />
              <label class="form-check-label" for="termo-1">Sim</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                data-cy="isSecondaryMarketFalse"
                id="termo-0"
                name="termo"
                type="radio"
                [value]="false"
                [(ngModel)]="this.model.isSecondaryMarket"
                [required]="isTED() || isCETIP()"
                (change)="setSettlementDateBySecondaryMarket()"
              />
              <label class="form-check-label" for="termo-0">Não</label>
            </div>
          </div>
        </div>

        <div
          class="col-4"
          [class.has-error]="hasError('operationValue')"
          *ngIf="isCETIP() || isTED()"
        >
          <label
            *ngIf="
              model.statusId == WorkFlowStatusEnum.PendingAdmApproval ||
              model.statusId == WorkFlowStatusEnum.WaitingPassiveApproval ||
              model.statusId == null
            "
            >Valor da Operação
            <fa-icon
              *ngIf="isFullRedemption()"
              [icon]="faInfoCircle"
              title="Os valores de resgate poderão sofrer alterações por conta do calculo da cota do fundo."
            ></fa-icon>
            <fa-icon
              [icon]="faInfoCircle"
              title="Valor Alterado"
              *ngIf="isOperationValueModified()"
            ></fa-icon
          ></label>
          <label
            *ngIf="
              model.statusId != WorkFlowStatusEnum.PendingAdmApproval &&
              model.statusId != WorkFlowStatusEnum.CancelledByAdm &&
              model.statusId != WorkFlowStatusEnum.WaitingPassiveApproval &&
              model.statusId != WorkFlowStatusEnum.CancelledByPassive &&
              model.statusId != null
            "
            >Valor da Operação Controladoria
            <fa-icon
              [icon]="faInfoCircle"
              title="Este foi o valor definido pela Controladoria"
            ></fa-icon
          ></label>
          <input
            type="text"
            data-cy="operationValue"
            class="form-control"
            name="operationValue"
            [disabled]="operationValueIsDisabled"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            maxlength="38"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <div
          *ngIf="
            model.statusId != WorkFlowStatusEnum.PendingAdmApproval &&
            model.statusId != WorkFlowStatusEnum.CancelledByAdm &&
            model.statusId != WorkFlowStatusEnum.WaitingPassiveApproval &&
            model.statusId != WorkFlowStatusEnum.CancelledByPassive &&
            model.statusId != null
          "
          class="col-4"
        >
          <label
            >Valor Inicial da Operação
            <fa-icon
              [icon]="faInfoCircle"
              title="Este foi o valor incial definido pelo gestor."
            ></fa-icon
          ></label>
          <input
            type="text"
            data-cy="oldOperationValue"
            class="form-control"
            name="oldOperationValue"
            readonly
            currencyMask
            [(ngModel)]="model.oldOperationValue"
          />
        </div>

        <app-out-custody></app-out-custody>
      </div>
      <div class="row mb-2" *ngIf="isSell()">
        <div class="col-4">
          <label>Código da Operação</label>
          <input
            data-cy="operationCode"
            type="text"
            class="form-control"
            name="operationCode"
            [(ngModel)]="model.operationCode"
            maxlength="20"
            [required]="isSell()"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4" *ngIf="isSell() || isNoFinancial()">
          <label>Data Aquisição</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="acquisitionDate"
            data-cy="acquisitionDate"
            [(ngModel)]="model.acquisitionDate"
            [required]="isNoFinancial()"
          />
        </div>

        <div class="col-4" *ngIf="isNoFinancial()">
          <label>Data da Subscrição</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="subscriptionDate"
            data-cy="subscriptionDate"
            [(ngModel)]="model.subscriptionDate"
            [required]="isNoFinancial()"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div *ngIf="!isEscritoTermo()" class="col-4">
          <label>Tipo de Ativo</label>
          <mat-select
            [class.required-active]="
              thisForm.touched && this.model.assetType == null
            "
            data-cy="assetType"
            class="form-control"
            [(value)]="this.model.assetType"
            [disabled]="!canEdit()"
            required
          >
            <mat-option [value]="-1">(nenhum)</mat-option>

            <mat-option
              *ngFor="let item of ListaTipoDoDoAtivo"
              name="assetType"
              [value]="item.name"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-4">
          <label>Código do Ativo/ IF</label>
          <input
            type="text"
            class="form-control"
            data-cy="assetCode"
            name="assetCode"
            maxlength="20"
            [(ngModel)]="model.assetCode"
            [required]="!isTED()"
          />
        </div>

        <div class="col-4" [class.has-error]="hasError('expirationDate')">
          <label>Data Vencimento</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="expirationDate"
            data-cy="expirationDate"
            [(ngModel)]="model.expirationDate"
            [required]="isPurchase()"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4" *ngIf="isNaoPadronizados()">
          <label>Número da proposta</label>
          <input
            data-cy="propositionNumber"
            type="text"
            class="form-control"
            name="propositionNumber"
            [(ngModel)]="model.propositionNumber"
            maxlength="20"
            [required]="isNaoPadronizados()"
          />
        </div>
        <div class="col-4" *ngIf="isCetipVoice()">
          <label for="isCetipVoice">Cetip Voice?</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                data-cy="isCetipVoice"
                [readonly]="true"
                class="form-check-input"
                id="isCetipVoiceId"
                name="isCetipVoice"
                [(ngModel)]="model.isCetipVoice"
                type="checkbox"
              />
            </div>
          </div>
        </div>
        <div class="col-4" *ngIf="isCetipVoice()">
          <label>Número Voice</label>
          <input
            type="text"
            class="form-control"
            data-cy="voiceNumber"
            name="voiceNumber"
            [(ngModel)]="model.voiceNumber"
            maxlength="20"
            [textMask]="{ mask: validator.cetipNumber, guide: false }"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Taxa Emissão</label>
          <input
            type="text"
            class="form-control"
            data-cy="issueFee"
            name="issueFee"
            [(ngModel)]="model.issueFee"
            maxlength="21"
            [textMask]="{ mask: validator.decimalRemunerationRateMask }"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <div class="col-4" [class.has-error]="hasError('issueDate')">
          <label>Data Emissão</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="issueDate"
            data-cy="issueDate"
            [(ngModel)]="model.issueDate"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <div class="col-4">
          <label>Emissor</label>
          <input
            type="text"
            data-cy="issuer"
            class="form-control"
            name="issuer"
            [(ngModel)]="model.issuer"
            maxlength="90"
            [required]="isSell() || isPurchase()"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Indexador</label>
          <input
            type="text"
            data-cy="index"
            class="form-control"
            name="index"
            [(ngModel)]="model.index"
            maxlength="8"
            [required]="isSell() || isPurchase()"
          />
        </div>
        <div class="col-4">
          <label>Percentual do Indexador</label>
          <input
            type="text"
            data-cy="indexPercent"
            class="form-control"
            name="indexPercent"
            [(ngModel)]="model.indexPercent"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <div *ngIf="isNaoPadronizados() || this.isSell()" class="col-4">
          <label>Taxa Indexador</label>
          <input
            type="text"
            class="form-control"
            data-cy="indexTax"
            name="indexTax"
            maxlength="50"
            [(ngModel)]="model.indexTax"
            [textMask]="{ mask: validator.decimalRemunerationRateMask }"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('indexBase')">
          <label>Base Indexador</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaBaseIndexador; index as i"
            >
              <input
                class="form-check-input"
                data-cy="indexBase"
                type="radio"
                id="indexBase-{{ i }}-id"
                name="indexBase"
                [(ngModel)]="model.indexBase"
                [value]="item.id"
              />

              <label class="form-check-label" for="indexBase-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-4" [class.has-error]="hasError('interestType')">
          <label for="termo">Tipo de Juros do Indexador</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaTipoJuros; index as i"
            >
              <input
                class="form-check-input"
                data-cy="interestType"
                type="radio"
                id="interestType-{{ i }}-id"
                name="interestType"
                [(ngModel)]="model.interestType"
                [value]="item.id"
                [required]="isSell() || isPurchase()"
              />

              <label class="form-check-label" for="interestType-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="isNaoPadronizados()" class="col-4">
          <label>Data Liquidação</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="settlementDate"
            data-cy="settlementDate"
            [(ngModel)]="model.settlementDate"
            [disabled]="model.isSecondaryMarket"
          />
        </div>
      </div>
    </div>
  </div>
  <br />

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.CETIP"
    [isSecondaryMarketCetip]="model.isSecondaryMarket"
    [isTedCETIP]="isTED()"
    [isCETIP]="isCETIP()"
    [isNoFinancialCETIP]="isNoFinancial()"
    [canValidate]="canValidate"
    [canEdit]="canEdit()"
    [model]="this.model"
  >
  </app-counterpart>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>
  <app-attachment
    #attachment
    [ticketId]="model.id"
    [canEdit]="canEdit()"
    [canChangeStatus]="canChangeStatus()"
    [statusDescription]="model.statusDescription"
    (tempTicketId)="setTempId($event)"
  ></app-attachment>

  <mat-expansion-panel *ngIf="showTransferStatus()" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Dados da Transferência </mat-panel-title>
      <mat-panel-description> (Clique para expandir...) </mat-panel-description>
    </mat-expansion-panel-header>
    <div style="padding: 1rem">
      <app-transfer-status
        #transferstatus
        [ticketId]="model.id"
      ></app-transfer-status>
    </div>
  </mat-expansion-panel>

  <br />
  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>
<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
